import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Modal, Toast, Badge, ActionSheet, Picker, List, Button, InputItem } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import CommonUtils from '../utils/CommonUtils';
import '../styles/AgentGame.css';

const history = require("history").createHashHistory()
const alert = Modal.alert

class AgentGame extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            selectedItem: null,
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            gameCategories: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 60;
        this.setState({
            height
        })
        this.loadGameCategories()
        this.loadPageData(1)
    }

    loadGameCategories = () => {
        DataFetcher.gameCategories({}, {
            success: (resp) => {
                this.setState({
                    gameCategories: resp.data
                })
            }
        })
    }

    loadPageData = (pageNum) => {
        DataFetcher.agentGames({
            pageNum,
            pageSize: 10,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    handleCreateClick = () => {
        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('create_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }

            const params = {
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('create_'.length)] = propValue
            }

            DataFetcher.createGame(params, {
                success: (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const params = {
                id: selectedItem.id,
                gameId: selectedItem.gameId,
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('update_'.length)] = propValue
            }

            DataFetcher.updateGame(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            })
        });
    }

    handleItemClick = (rowData) => {
        const options = [
            { icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' }
        ]
        if(rowData.status === 1) {
            options.push({ icon: <i className='iconfont icon-tingyong' style={{color:'gray', fontSize: 40}}/>, title: '下架' })
        } else {
            options.push({ icon: <i className='iconfont icon-qiyong' style={{color:'green', fontSize: 40}}/>, title: '上架' })
        }
        if(rowData.id && !rowData.gameId) {
            options.push({ icon: <i className='iconfont icon-shanchu1' style={{color:'red', fontSize: 40}}/>, title: '删除' })
        }

        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.deviceName?rowData.deviceName:rowData.deviceId,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '上架') {
                this.handleEnableClick(rowData)
            } else if(buttonTitle === '下架') {
                this.handleDisableClick(rowData)
            } else if(buttonTitle === '删除') {
                this.handleDeleteClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleEnableClick = (rowData) => {
        if(!rowData) return

        alert('确认要上架游戏?', rowData.name, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.enableGame({
                    id: rowData.id?rowData.id:rowData.gameId
                }, {
                    success: (resp) => {
                        Toast.info('游戏已上架', 2)
                        this.loadPageData(1)
                    }
                })
            }},
          ])
    }

    handleDisableClick = (rowData) => {
        if(!rowData) return

        alert('确认要下架游戏?', rowData.name, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.disableGame({
                    id: rowData.id?rowData.id:rowData.gameId
                }, {
                    success: (resp) => {
                        Toast.info('游戏已下架', 2)
                        this.loadPageData(1)
                    }
                })
            }},
          ])
    }

    handleDeleteClick = (rowData) => {
        if(!rowData) return

        alert('确认要删除游戏?', rowData.name, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.deleteGame(rowData.id, 
                {
                    success: (resp) => {
                        Toast.info('游戏已删除', 2)
                        this.loadPageData(1)
                    }
                })
            }},
          ])
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        let onlineBadge = (
            <Badge text={rowData.status&&rowData.status===1?'上架':'下架'} 
                   style={{backgroundColor: `${rowData.status&&rowData.status===1?'#04bbc5':'gray'}`}}/>)

        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.name}</span>}
                            extra={onlineBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>标&nbsp;&nbsp;&nbsp;签：</span> 
                                    <span>{rowData.label}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>类&nbsp;&nbsp;&nbsp;别：</span> 
                                    <span>{CommonUtils.resolveDictText(rowData.category, this.state.gameCategories, 'code', 'name')}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>游&nbsp;&nbsp;&nbsp;戏：</span> 
                                    <span>{rowData.execPath}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>进&nbsp;&nbsp;&nbsp;程：</span> 
                                    <span>{rowData.processName}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>封&nbsp;&nbsp;&nbsp;面：</span> 
                                    <span>{rowData.thumbnail}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>视&nbsp;&nbsp;&nbsp;频：</span> 
                                    <span>{rowData.video}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>最低版本：</span> 
                                    <span>{rowData.minAppVersion?rowData.minAppVersion:'不限'}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>最高版本：</span> 
                                    <span>{rowData.maxAppVersion?rowData.maxAppVersion:'不限'}</span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, gameCategories} = this.state
        const gameCategoryPickerData = CommonUtils.generatePickerOptionsFromList(gameCategories, 'code', 'name')
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>新增游戏</div>}>
                        <Picker 
                            cols={1}
                            data={gameCategoryPickerData}
                            {...getFieldProps('create_category', {
                                initialValue: []
                            })} 
                            >
                            <List.Item arrow="horizontal">类型</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('create_name', {
                            initialValue: null,
                            rules: [{required: true, message: '请填写名称'}],
                        })}>
                            名称
                        </InputItem>
                        <InputItem placeholder='游戏路径;如D:\xx\xx.exe' {...getFieldProps('create_execPath', {
                            initialValue: null,
                            rules: [{required: true, message: '请填写游戏'}],
                        })}>
                            游戏
                        </InputItem>
                        <InputItem placeholder='游戏进程名;如xx.exe' {...getFieldProps('create_processName', {
                            initialValue: null,
                            rules: [{required: true, message: '请填写进程'}],
                        })}>
                            进程
                        </InputItem>
                        <InputItem placeholder='封面路径;如D:\xx\xx.jpg' {...getFieldProps('create_thumbnail', {
                            initialValue: null,
                            rules: [{required: true, message: '请填写封面'}],
                        })}>
                            封面
                        </InputItem>
                        <InputItem placeholder='视频路径;如D:\xx\xx.mp4' {...getFieldProps('create_video', {
                            initialValue: null,
                            rules: [{required: true, message: '请填写视频'}],
                        })}>
                            视频
                        </InputItem>
                        <InputItem placeholder='标签;可选' {...getFieldProps('create_label', {
                            initialValue: null
                        })}>
                            标签
                        </InputItem>
                        <InputItem placeholder='最低版本;可选;如1.0.0' {...getFieldProps('create_minAppVersion', {
                            initialValue: null
                        })}>
                            最低版本
                        </InputItem>
                        <InputItem placeholder='最高版本;可选;如9.0.0' {...getFieldProps('create_maxAppVersion', {
                            initialValue: null
                        })}>
                            最高版本
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem, gameCategories} = this.state
        const gameCategoryPickerData = CommonUtils.generatePickerOptionsFromList(gameCategories, 'code', 'name')
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <Picker 
                            cols={1}
                            data={gameCategoryPickerData}
                            {...getFieldProps('update_category', {
                                initialValue: selectedItem&&selectedItem.category?[selectedItem.category]:[],
                            })} 
                            >
                            <List.Item arrow="horizontal">类型</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('update_name', {
                            initialValue: selectedItem?selectedItem.name:null,
                            rules: [{required: true, message: '请填写名称'}],
                        })}>
                            名称
                        </InputItem>
                        <InputItem placeholder='游戏路径;如D:\xx\xx.exe' {...getFieldProps('update_execPath', {
                            initialValue: selectedItem?selectedItem.execPath:null,
                            rules: [{required: true, message: '请填写游戏'}],
                        })}>
                            游戏
                        </InputItem>
                        <InputItem placeholder='游戏进程名;如xx.exe' {...getFieldProps('update_processName', {
                            initialValue: selectedItem?selectedItem.processName:null,
                            rules: [{required: true, message: '请填写进程'}],
                        })}>
                            进程
                        </InputItem>
                        <InputItem placeholder='封面路径;如D:\xx\xx.jpg' {...getFieldProps('update_thumbnail', {
                            initialValue: selectedItem?selectedItem.thumbnail:null,
                            rules: [{required: true, message: '请填写封面'}],
                        })}>
                            封面
                        </InputItem>
                        <InputItem placeholder='视频路径;如D:\xx\xx.mp4' {...getFieldProps('update_video', {
                            initialValue: selectedItem?selectedItem.video:null,
                            rules: [{required: true, message: '请填写视频'}],
                        })}>
                            视频
                        </InputItem>
                        <InputItem placeholder='标签;可选' {...getFieldProps('update_label', {
                            initialValue: selectedItem?selectedItem.label:null
                        })}>
                            标签
                        </InputItem>
                        <InputItem placeholder='最低版本;可选;如1.0.0' {...getFieldProps('update_minAppVersion', {
                            initialValue: selectedItem?selectedItem.minAppVersion:null
                        })}>
                            最低版本
                        </InputItem>
                        <InputItem placeholder='最高版本;可选;如9.0.0' {...getFieldProps('update_maxAppVersion', {
                            initialValue: selectedItem?selectedItem.maxAppVersion:null
                        })}>
                            最高版本
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const { dataSource, isLoading } = this.state;
        let rightContent = <i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>

        return (
            <div className='page-game'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={rightContent}
                >
                    游戏管理
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 60
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
            </div>
        )
    }
}

export default createForm()(AgentGame);


// WEBPACK FOOTER //
// ./src/modules/AgentGame.js